import { type FC } from 'react'
import { Button } from 'shared/ui'

type IChatActionProps = {
  disabled: boolean
  onClick: () => void
  className?: string
}

export const ChatAction: FC<IChatActionProps> = ({ disabled, onClick, className }) => {
  return (
    <Button
      size='medium'
      typeBtn='contained'
      contained='secondary'
      icon='messageTextCircle02'
      iconProps={{
        color: disabled ? 'var(--content-neutral-primary)' : 'var(--content-primary-tertiary)',
      }}
      text='Chat'
      disabled={disabled}
      className={className}
      tooltipProps={{
        label: 'Send message',
      }}
      onClick={onClick}
    />
  )
}
